import { useContext } from 'react';
import {
  PromptContext,
  SnackbarContext,
  SnackbarVariant,
  UserSettingsContext,
} from '@eas/common-web';
import {
  CalendarHandle,
  CalendarSettingsType,
} from '../calendar/calendar-types';
import { settingsId, settingsVersion } from './settings';

export function useSettingsSubmit({
  calendarRef,
}: {
  calendarRef: React.RefObject<CalendarHandle>;
}) {
  const { testPrompt } = useContext(PromptContext);
  const { setCustomSettings } = useContext(UserSettingsContext);
  const { showSnackbar } = useContext(SnackbarContext);

  const handleClick = () =>
    testPrompt({
      key: 'PLANNER_SETTINGS_DIALOG',
      submitCallback: async (values: Partial<CalendarSettingsType>) => {
        const newSettings: Partial<CalendarSettingsType> = {
          stepWidth: values.stepWidth,
          startingHour: values.startingHour,
          endingHour: values.endingHour,
          colorForShiftV: values.colorForShiftV,
          colorForShiftZ: values.colorForShiftZ,
          colorForShiftZP: values.colorForShiftZP,
          colorForShiftA: values.colorForShiftA,
          colorForShiftP: values.colorForShiftP,
          pinnedMap: values.pinnedMap,
          groupToMultitaskCount: values.groupToMultitaskCount,
          legendWidth: values.legendWidth,
          legendCollapsed: values.legendCollapsed,
          legendSort: values.legendSort,
          rowHeight: values.rowHeight,
        };

        setCustomSettings(settingsId, {
          ...calendarRef.current?.settings,
          ...newSettings,
          version: settingsVersion,
        });

        calendarRef.current?.setSettings((oldSettings) => {
          console.log({ oldSettings, newSettings });
          return {
            ...oldSettings,
            ...newSettings,
          };
        });

        calendarRef?.current?.clearPinnedMapData?.();

        showSnackbar(
          'Nastavenia boli úspešne uložené',
          SnackbarVariant.SUCCESS
        );
      },
    });

  return { handleClick };
}
